import React from 'react';
import { ArrowRightIcon, MapPinIcon, PhoneIcon } from 'lucide-react';
import { ButtonLink } from './ButtonLink';
import { Eyebrow } from './Eyebrow';
import { quoteChecklist } from '../data/content';
import { contact, urls } from '../data/site';
export function ContactSection() {
  return <section id="contact" aria-labelledby="contact-heading" className="focus-light bg-brand py-14 text-white md:py-28" data-id="element-24" data-mp="2pi78ooydbo8t">
      <div className="mx-auto max-w-[1320px] px-5 sm:px-8 lg:px-12" data-id="element-25" data-mp="3d9cmyzonu8h0">
        <h2 id="contact-heading" className="font-display text-[48px] font-bold uppercase leading-[0.9] sm:text-[64px] md:text-[84px] lg:text-[100px]" data-id="element-26" data-mp="3i75qfkykwodl">
          Let's talk about{' '}
          <br data-id="element-27" data-mp="388gjuoc4uqcn" />
          your truck.
        </h2>

        <div className="mt-12 grid gap-10 md:mt-16 lg:grid-cols-12 lg:gap-12" data-id="element-28" data-mp="38bb4afv5cb62">
          <div className="lg:col-span-5" data-id="element-29" data-mp="1sqwlfzn8hxkc">
            <Eyebrow tone="red" data-id="element-30" data-mp="1wu2wdklakcx5">Call or visit the shop</Eyebrow>
            <a href={contact.phoneHref} className="mt-5 inline-block font-display text-[44px] font-bold leading-none tracking-[0.01em] underline decoration-white/40 decoration-2 underline-offset-8 transition-colors duration-150 ease-out hover:decoration-white md:text-[56px]" data-id="element-31" data-mp="1wve2hr27lwrf">
              {contact.phoneDisplay}
            </a>
            <address className="mt-8 flex items-start gap-3 text-[17px] not-italic leading-relaxed" data-id="element-32" data-mp="ck6gqf3ay34p">
              <MapPinIcon aria-hidden="true" className="mt-1 h-5 w-5 shrink-0" data-id="element-33" data-mp="qjz7ubiqqld7" />
              <span data-id="element-34" data-mp="lmpj6y36edqf">
                {contact.name}
                <br data-id="element-35" data-mp="ljtjb47rpezc" />
                {contact.street}
                <br data-id="element-36" data-mp="109sfx2jocicp" />
                {contact.cityLine}
              </span>
            </address>
            <p className="mt-5 max-w-[26rem] text-[15px] leading-relaxed text-white" data-id="element-37" data-mp="vbh8szkrkly6">
              Based in Brighton, serving fleets, owner operators and contractors across Southeast Michigan.
            </p>
            <div className="mt-8 flex flex-col gap-3 sm:flex-row" data-id="element-38" data-mp="14dqftfgtpx6t">
              <ButtonLink href={contact.phoneHref} variant="ink" leadingIcon={PhoneIcon} className="w-full sm:w-auto" data-id="element-39" data-mp="1z99ydo2vcba">
                Call the Shop
              </ButtonLink>
              <ButtonLink href={urls.directions} variant="outlineRed" leadingIcon={MapPinIcon} className="w-full sm:w-auto" data-id="element-40" data-mp="6vpyh8z6vsow">
                Get Directions
              </ButtonLink>
            </div>
          </div>

          <div className="bg-ink p-7 text-paper md:p-10 lg:col-span-7" data-id="element-41" data-mp="kpr2ah5005w4">
            <h3 className="font-display text-[30px] font-bold uppercase leading-none md:text-[36px]" data-id="element-42" data-mp="krld32mk2hmh">
              Start a photo quote
            </h3>
            <p className="mt-3 text-[16px] text-steel-light" data-id="element-43" data-mp="uoq2rcfm0v81">Have these ready before you open the quote form:</p>
            <ol className="mt-7 grid gap-px bg-ink-line sm:grid-cols-2" data-id="element-44" data-mp="ynyxajih4x4n">
              {quoteChecklist.map((item, i) => <li key={item.title} className="flex gap-4 bg-ink py-5 sm:p-5" data-id="element-45" data-mp="2wh4hy3qrrlkr" data-mpi={i}>
                  <span className="font-display text-[22px] font-bold leading-none text-brand-bright" data-id="element-46" data-mp="30h564g3o7b50">
                    {String(i + 1).padStart(2, '0')}
                  </span>
                  <span data-id="element-47" data-mp="2o5cj5pwh8hb5">
                    <span className="block text-[16px] font-semibold text-paper" data-id="element-48" data-mp="2o52rzyzp443v">{item.title}</span>
                    <span className="mt-1 block text-[15px] leading-snug text-steel-light" data-id="element-49" data-mp="2j7kia6dutkut">{item.description}</span>
                  </span>
                </li>)}
            </ol>
            <div className="mt-8 flex flex-col gap-5 border-t border-ink-line pt-8 md:flex-row md:items-center md:justify-between" data-id="element-50" data-mp="3bvgdf6nrz4ph">
              <p className="text-[15px] text-steel-light" data-id="element-51" data-mp="32va1hp7q6csf">
                <span className="font-semibold text-paper" data-id="element-52" data-mp="32tqk1vac1vp2">Vehicle details + damage photos</span> = a better first
                conversation.
              </p>
              <ButtonLink href={urls.quote} trailingIcon={ArrowRightIcon} className="w-full shrink-0 md:w-auto" data-id="element-53" data-mp="1rgo492g25a5y">
                Start a Photo Quote
              </ButtonLink>
            </div>
          </div>
        </div>
      </div>
    </section>;
}